import {
  beebee,
  bloodbond,
  careHelper,
  dShiftify,
  eventCook,
  fairInSight,
  happychild,
  hiretab,
  myevents,
  provo,
  safeAlert,
  shortener,
  smartfood,
  unigo,
} from "assets/images";

export interface ProductItem {
  name: string;
  description: string;
  img: string;
  colorScheme: string;
  objectFit?: "cover" | "contain";
  bgColor?: string;
}

export const PRODUCTS: ProductItem[] = [
  {
    name: "Unigo",
    description:
      "Hệ thống mô phỏng bản đồ trường Đại Học Bách Khoa - Đại học Đà Nẵng",
    img: unigo,
    colorScheme: "google.red",
  },
  {
    name: "BeeBee Travel",
    description:
      "Nền tảng (B2B) kết nối các doanh nghiệp cung cấp các dịch vụ du lịch",
    img: beebee,
    colorScheme: "google.green",
  },
  {
    name: "Provo",
    description:
      "Hệ sinh thái học tiếng Anh cung cấp các dịch vụ như: học từ vựng tiếng anh hay hỗ trợ sửa lỗi IELTS Writing,...",
    img: provo,
    colorScheme: "google.yellow",
  },
  {
    name: "GDGoC-DUT URL Shortener",
    description: "Công cụ hỗ trợ rút gọn link được phát triển bởi GDGoC-DUT",
    img: shortener,
    colorScheme: "google.blue",
  },
  {
    name: "Event Cookbook",
    description: "Cẩm nang tổ chức sự kiện",
    img: eventCook,
    colorScheme: "google.green",
  },
  {
    name: "Smartfood",
    description: "Ứng dụng gợi ý công thức nấu ăn từ thực phẩm có sẵn",
    img: smartfood,
    colorScheme: "google.yellow",
  },
  {
    name: "MyEvents",
    description: "Ứng dụng quản lý tổ chức sự kiện",
    img: myevents,
    colorScheme: "google.red",
  },
  {
    name: "HappyChild",
    description:
      "Nền tảng hỗ trợ phụ huynh xác định sớm, đánh giá và nuôi dạy trẻ tự kỷ",
    img: happychild,
    colorScheme: "google.blue",
  },

  {
    name: "BloodBond",
    description: "Nền tảng hỗ trợ công tác hiến máu",
    img: bloodbond,
    colorScheme: "google.red",
  },
  {
    name: "SharingHub",
    description: "Ứng dụng hỗ trợ hoạt động thiện nguyện",
    img: shortener,
    colorScheme: "google.yellow",
  },
  {
    name: "CareHelper",
    description:
      "Nền tảng hỗ trợ chăm sóc sức khỏe và theo dõi thể trạng thông minh",
    img: careHelper,
    colorScheme: "google.blue",
  },
  {
    name: "Safe Alert",
    description:
      "Hệ thống cảnh báo an toàn và hỗ trợ ứng cứu khẩn cấp thời gian thực",
    img: safeAlert,
    colorScheme: "google.red",
  },
  {
    name: "HireTab",
    description:
      "Nền tảng ứng dụng AI tự động sàng lọc, đánh giá CV và tối ưu hóa quy trình tuyển dụng cho doanh nghiệp",
    img: hiretab,
    colorScheme: "google.blue",
    objectFit: "contain",
    bgColor: "white",
  },
  {
    name: "FairInSight",
    description:
      "Nền tảng LegalTech ứng dụng AI hỗ trợ tra cứu, phân tích pháp lý và kết nối người dân với luật sư",
    img: fairInSight,
    colorScheme: "google.red",
  },
  {
    name: "D-Shiftify",
    description:
      "Nền tảng tuyển dụng và kết nối việc làm hòa nhập cho người khuyết tật, tích hợp công nghệ trợ năng và AI",
    img: dShiftify,
    colorScheme: "google.green",
    objectFit: "contain",
    bgColor: "white",
  },
];
